import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/Button/Button';

import styles from './apps.scss';

export function AppInstall(props) {
    const { name, description, iconPath, onAddClick } = props;

    return (
        <div className={styles.appInstall}>
            <div className={styles.appIcon} style={{ backgroundImage: iconPath }} />
            <div className={styles.appInfo}>
                <h2>{name}</h2>
                <p>{description}</p>
            </div>
            <Button text={'Добавить'} level={'tertiary'} size={'s'} onClick={onAddClick} />
        </div>
    );
}

AppInstall.propTypes = {
    name: PropTypes.string,
    description: PropTypes.string,
    iconPath: PropTypes.string,
    onAddClick: PropTypes.func,
};
